import template from "./proof-of-play-reports-v2-list.component.html";

class ProofOfPlayReportsV2ListComponentController {
  constructor(
    $stateParams,
    $interval,
    $window,
    ProofOfPlayReportsV2Service,
    StorageService,
  ) {
    'ngInject';
    this.$stateParams = $stateParams;
    this.$interval = $interval;
    this.$window = $window;
    this.ProofOfPlayReportsV2Service = ProofOfPlayReportsV2Service;
    this.StorageService = StorageService;
  }

  $onInit() {
    this.refreshReports();
    this.refreshInterval = this.$interval(() => {
      this.refreshReports();
    }, 7000);
  }

  $onDestroy() {
    if (this.refreshInterval) {
      this.$interval.cancel(this.refreshInterval);
    }
  }

  refreshReports() {
    let params = {
      tenantId: this.$stateParams.tenantId,
    };
    this.ProofOfPlayReportsV2Service.getList(params) // Note: magic apiRestangular method, calls list method on endpoint
      .then(response => {
        this.reports = response;
      }, error => {
        console.error('unable to load reports', error);
      });
  }

  isCompleted(report) {
    return this.ProofOfPlayReportsV2Service.isCompleted(report);
  }

  downloadUrl(report) {
    return this.ProofOfPlayReportsV2Service.downloadUrl(report);
  }
}

export const ProofOfPlayReportsV2ListComponent = {
  template: template,
  controller: ProofOfPlayReportsV2ListComponentController,
};
